module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "showcell"
  }, [_c('div', {
    staticClass: "header"
  }, [(_vm.typeIcon === 'A') ? _c('div', [_c('div', {
    staticClass: "icon1"
  })]) : (_vm.typeIcon === 'B') ? _c('div', [_c('div', {
    staticClass: "icon2"
  })]) : (_vm.typeIcon === 'C') ? _c('div', [_c('div', {
    staticClass: "icon3"
  })]) : (_vm.typeIcon === 'D') ? _c('div', [_c('div', {
    staticClass: "icon4"
  })]) : _c('div', [_c('div', {
    staticClass: "icon5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "title",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.typeIcon === 'B') ? _c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.jump
      }),
      expression: "{methods:jump}"
    }]
  }, [_c('div', {
    staticClass: "jump"
  })]) : _vm._e(), _vm._v(" "), (_vm.typeIcon === 'C') ? _c('div', [_c('router-link', {
    attrs: {
      "to": "/record-aboutCourse"
    }
  }, [_c('div', {
    staticClass: "jump"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.typeIcon === 'D') ? _c('div', [_c('router-link', {
    attrs: {
      "to": "/record-completedCourse"
    }
  }, [_c('div', {
    staticClass: "jump"
  })])], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fd3b443"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VShowCell.vue
// module id = 773
// module chunks = 1